const Spinner = () => {
  return (
    <div className='my-auto mx-auto'>
      <span className='spinner-border spinner-border-xl ms-2 text-primary'></span>
    </div>
  )
}


export default Spinner